import { useState } from 'react';
import { formatJMD } from '../../lib/finances';
import { PAYMENT_METHODS } from '../../lib/invoices';
import { todayISO } from '../../lib/dates';

// Recording a payment — one month's statement on a consignment, or a direct
// invoice settled in full. Both go through here so the questions asked, and
// what lands in Accounting, are identical.
//
// It asks rather than assumes, because this is the moment money enters the
// books: the date decides which month the income lands in for tax, and the
// reference is what you match against a bank statement later. Defaulting the
// date to today and letting it be changed is the compromise — the payment
// often lands a few days before it gets recorded here.
export default function MarkPaidDialog({
  subtitle,
  amount,
  defaultMethod = 'Bank Transfer',
  note,
  onSubmit,
  onCancel,
}) {
  const [paidOn, setPaidOn] = useState(todayISO());
  const [method, setMethod] = useState(defaultMethod || 'Bank Transfer');
  const [reference, setReference] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      await onSubmit({ paidOn, method, reference: reference.trim() || null });
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div className="dialog-backdrop" role="dialog" aria-modal="true" aria-label="Mark payment received">
      <form className="dialog dialog-narrow" onSubmit={handleSubmit}>
        <h3>Payment received</h3>
        <p className="dialog-sub">{subtitle}</p>

        <div className="dialog-amount">
          <span>Amount</span>
          <strong>{formatJMD(amount)}</strong>
        </div>

        <label className="field">
          <span>Payment date</span>
          <input type="date" value={paidOn} onChange={(e) => setPaidOn(e.target.value)} />
        </label>

        <label className="field">
          <span>Payment method</span>
          <select value={method} onChange={(e) => setMethod(e.target.value)}>
            {PAYMENT_METHODS.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </label>

        <label className="field">
          <span>Reference (optional)</span>
          <input
            value={reference}
            onChange={(e) => setReference(e.target.value)}
            placeholder="Transfer or cheque number"
          />
        </label>

        <p className="dialog-note">
          This adds {formatJMD(amount)} to Accounting → Income, dated {paidOn}.
          {note ? ` ${note}` : ''}
        </p>

        {error && <p className="po-error">{error}</p>}

        <div className="dialog-actions">
          <button type="button" className="ghost-button" onClick={onCancel}>
            Cancel
          </button>
          <button type="submit" className="primary-action" disabled={saving}>
            {saving ? 'Recording…' : 'Mark paid'}
          </button>
        </div>
      </form>
    </div>
  );
}
